export default "__VITE_ASSET__DJfcn$Gm__"